export const SITE_DEPENDENT_ROLES = [
  'Center Admin',
  'Client',
  'Consultant',
  'Rezeption',
  'Trainer'
]